import { useEffect } from "react";

const DEFAULTS = {
  title: "Bilgece.life — Yaşamı öğrenmenin yolu",
  description: "Bilgece; çocuklardan ebeveynlere, öğretmenlerden liderlere uzanan bir öğrenme ve yaşam ekosistemidir. Daha çok bilmek için değil, daha bilgece yaşamak için.",
  image: "https://images.pexels.com/photos/38696179/pexels-photo-38696179.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, image, type = "website", jsonLd }) {
  useEffect(() => {
    const t = title ? `${title} | Bilgece.life` : DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const img = image || DEFAULTS.image;
    const url = window.location.href;

    document.title = t;
    document.documentElement.lang = "tr";
    upsertMeta("name", "description", d);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
    upsertMeta("name", "twitter:image", img);
    upsertLink("canonical", url.split("?")[0]);

    let script = document.getElementById("jsonld-dynamic");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "jsonld-dynamic";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, image, type, jsonLd]);

  return null;
}
